// axios-config.js
import { createApp } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';

const app = createApp({});

app.config.globalProperties.$axios = axios;

// axios.defaults.baseURL = 'https://dev.directory-uae.rojetah.com/api/';
axios.defaults.baseURL = 'https://trainingback.fci.group/api/';

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(response => response, async error => {
  const originalRequest = error.config;
  if (error.response.status === 401 && originalRequest.url.includes('refresh-token')) {
    localStorage.removeItem('token');
    router.push('/login');
    return Promise.reject(error);
  }
  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    await store.dispatch('login/refreshToken');
    return axios(originalRequest);
  }
  return Promise.reject(error);
});

export default app;
